import { onError } from '@apollo/client/link/error';
export const doRefresh = () => {
    console.error('Reloading due to an authentication error');
    window.location.reload();
};
/*
  A Link used to force a page refresh on errors which indicate that the user's login credentials have expired.'
*/
export const makeErrorLink = () => {
    return onError(({ graphQLErrors, networkError }) => {
        var _a;
        if (graphQLErrors) {
            graphQLErrors.forEach((err) => {
                var _a;
                if (((_a = err.extensions) === null || _a === void 0 ? void 0 : _a.code) === 'UNAUTHENTICATED') {
                    doRefresh();
                }
            });
        }
        if (((_a = networkError) === null || _a === void 0 ? void 0 : _a.statusCode) === 401) {
            doRefresh();
        }
    });
};
